import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";

interface DownloadCSVProps {
  onClickDownload: () => void;
}

export const DownloadCSV = ({ onClickDownload }: DownloadCSVProps) => (
  <div className="grid grid-cols-2 pr-2 font-medium">
    <p className="pr-1">{t("live_streams.dashboard.participants.csv")}</p>
    <Icon
      type="download"
      className="cursor-pointer"
      onClick={onClickDownload}
    />
  </div>
);
